import { createSlice,PayloadAction} from '@reduxjs/toolkit';


const initialState = {
  searchValue:'',//首页搜索框的值
  classificationText:{
    product_category_id:0,
    product_category_name:'',
  },//首页分类的值
  isMobile:false,//是否手机端
  yourTownloopSearchValue:'',//yourTownloop搜索框的值
};

const searchBarSlice = createSlice({
  name: 'serchBar',
  initialState,
  reducers: {
    setSearchValue:(state,action: PayloadAction<any>)=>{
      state.searchValue = action.payload;
      console.log('state.searchValue',state.searchValue);
      
    },
    clearSearchValue:(state)=>{
      state.searchValue = '';
    },

    setYourTownloopSearchValue:(state,action: PayloadAction<any>)=>{
      state.yourTownloopSearchValue = action.payload;
      console.log('state.yourTownloopSearchValue',state.yourTownloopSearchValue);
      
    },
    clearYourTownloopSearchValue:(state)=>{
      state.yourTownloopSearchValue = '';
    },

    setClassificationText:(state,action: PayloadAction<any>)=>{
      state.classificationText = action.payload;
      console.log('state.classificationText',state.classificationText);
      
    },
    clearClassificationText:(state)=>{
      state.classificationText = {
        product_category_id:0,
        product_category_name:'',
      };
    },
    //区分手机端和移动端
    setMobile:(state,action: PayloadAction<any>)=>{
      state.isMobile = action.payload;
      //console.log('state.isMobile',state.isMobile);
      
    },
  },
});

export const { 
  setSearchValue, 
  clearSearchValue,
  setClassificationText,
  clearClassificationText,
  setMobile,
  setYourTownloopSearchValue,
  clearYourTownloopSearchValue,
} = searchBarSlice.actions;

export default searchBarSlice.reducer; 